<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        :class="!isMobile? 'my-2 mx-3 card boxStyle' :'mx-auto my-2 card boxStyle'"
                        md="2"
                        :data-img="image.id"
                >
                    <v-radio-group class="p-0 m-0" v-model="selectedImage">
                        <v-radio
                                color="indigo"
                                :value="image.value"
                        ></v-radio>
                    </v-radio-group>
                    <img :src="image.full_path" class="img-fluid"
                         :key="image.id">
                    <p class="text-center my-0 pt-2">{{ image.name }}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "setDesignType",
    data() {
        return {
            selectedImage: [],
            img: [
                {
                    id: '1',
                    name: 'خلاق',
                    value: 'innovative',
                    full_path: require('../../../../public/media/site/setShape/2/خلاق.jpg')
                },
                {
                    id: '2',
                    name: 'ساده',
                    value: 'simple',
                    full_path: require('../../../../public/media/site/setShape/2/ساده-.jpg')
                },
                {
                    id: '3',
                    name: 'لوکس',
                    value: 'luxury',
                    full_path: require('../../../../public/media/site/setShape/2/لوکس.jpg')
                },
                {
                    id: '4',
                    name: 'کلاسیک',
                    value: 'classic',
                    full_path: require('../../../../public/media/site/setShape/2/کلاسیک.jpg')
                },
                {
                    id: '5',
                    name: 'اداری/سازمانی',
                    value: 'office',
                    full_path: require('../../../../public/media/site/setShape/2/سازمان.jpg')
                },
                {
                    id: '6',
                    name: 'فانتزی',
                    value: 'fantasy',
                    full_path: require('../../../../public/media/site/setShape/2/فانتزی.jpg')
                },
                {
                    id: '7',
                    name: 'عمومی',
                    value: 'public',
                    full_path: require('../../../../public/media/site/setShape/2/عمومی.jpg')
                },
                {
                    id: '8',
                    name: 'مدرن',
                    value: 'modern',
                    full_path: require('../../../../public/media/site/setShape/مدرن.jpg')
                },
            ],
            count: 1,
        }
    },
    watch:{
        selectedImage() {
            this.$emit('persianName',this.img.find((x)=>x.value === this.selectedImage).name,"setDesignType")
            this.$emit('input', this.selectedImage)
        }
    }
}
</script>

<style scoped>

</style>